export default {
  AUTH_COOKIE_NAME: 'Yola',
};
